export default {
  check_status: {
    verified: 'Verificato',
    pending: 'In attesa',
    failed: 'Non riuscito',
    not_applicable: 'Non necessario',
    required: 'Obbligatorio',
  },
  records: {
    type: 'Tipo',
    name: 'Nome',
    value: 'Valore',
    status: 'Stato',
    certificate: 'Certificato',
    certificate_hint: 'Emesso automaticamente quando i record sopra vengono trovati.',
    full_name: 'Nome completo:',
  },
  check_hint: {
    found: 'È stato trovato {{values}} al suo posto. Sostituiscilo con il valore indicato.',
    missing: 'Questo record non è stato trovato.',
    certificate:
      'Non è stato possibile emettere il certificato. Correggi i record segnalati sopra e controlla di nuovo.',
    certificate_unknown:
      "Non è stato possibile emettere il certificato. Controlla di nuovo più tardi e contatta l'assistenza se la situazione non cambia.",
    regressed: 'Questo record era stato verificato in precedenza e non viene più trovato.',
    technical: 'Dettaglio tecnico: {{error}}',
    held_by_another_project:
      "{{name}} è usato da un altro sito web su Vercel, quindi non può inoltrare i visitatori al negozio su www.{{name}}. Perché anche {{name}} apra il negozio, rimuovi prima il dominio da quell'altro sito web.",
    certificate_pending: {
      not_attached: 'In corso: stiamo aggiungendo il dominio dalla nostra parte.',
      awaiting_dns: 'In corso: il certificato viene emesso non appena vengono trovati i record sopra.',
      awaiting_certificate:
        'In corso: i record puntano a noi e il certificato è in fase di emissione. Di solito ci vogliono pochi minuti.',
    },
    certificate_failed: {
      ownership_proof_required:
        '{{name}} è collegato anche a un altro account Vercel. Per dimostrare che è tuo, aggiungi anche i record TXT qui sotto presso il provider DNS e controlla di nuovo.',
      held_by_another_project:
        'Un altro sito web su Vercel usa già {{name}}. Rimuovi prima il dominio da quel sito web e controlla di nuovo, oppure usa un altro dominio.',
      dns_correct_but_unconfigured:
        "I record sopra sono corretti, ma qualcos'altro su {{name}} blocca il certificato. Rimuovi eventuali record AAAA su quel nome, disattiva eventuali proxy davanti (come la nuvola arancione di Cloudflare) e assicurati che nessun record CAA escluda Let’s Encrypt. Poi controlla di nuovo.",
      name_mismatch:
        "{{name}} risponde con un certificato per {{names}}. Assicurati che i record sopra siano gli unici su {{name}}; se lo sono, contatta l'assistenza.",
      name_mismatch_unnamed:
        "{{name}} risponde con un certificato per un altro nome. Assicurati che i record sopra siano gli unici su {{name}}; se lo sono, contatta l'assistenza.",
      expired:
        'Il certificato è scaduto e non è stato rinnovato. Abbiamo ricevuto la segnalazione e ce ne stiamo occupando: per ora non devi fare nulla.',
      expiring:
        'Il certificato scade a breve e non è ancora stato rinnovato. Ce ne stiamo occupando: per ora non devi fare nulla.',
      attach_refused:
        "Il nostro provider di hosting ha rifiutato di aggiungere {{name}} dalla nostra parte. Siamo stati avvisati e stiamo verificando: per ora non c'è nulla da cambiare presso il provider DNS.",
    },
    certificate_overdue: {
      not_attached:
        "Dopo 48 ore non è stato ancora possibile aggiungere il dominio dalla nostra parte. Contatta l'assistenza.",
      awaiting_dns:
        'Dopo 48 ore è ancora in attesa dei record sopra. Correggi i record segnalati sopra e controlla di nuovo.',
      awaiting_dns_records_verified:
        "Ancora non emesso dopo 48 ore, anche se i record sopra sono verificati. Contatta l'assistenza.",
      awaiting_certificate:
        "I record puntano a noi, ma il certificato non è ancora stato emesso dopo 48 ore. Contatta l'assistenza.",
    },
    certificate_dates: {
      valid_until: 'Valido fino al {{date}}.',
      expires_on: 'Scade il {{date}}.',
      expired_on: 'Scaduto il {{date}}.',
    },
  },
};
